import { supabase } from "@/integrations/supabase/client";

export type AdType = "sponsored" | "in_row" | "banner";

/**
 * Fire-and-forget click logger. Silent on failure so ad UX is never blocked.
 */
export const trackAdClick = (adType: AdType, adId: string | null | undefined) => {
  if (!adId) return;
  try {
    const path = typeof window !== "undefined" ? window.location.pathname : null;
    void supabase.auth.getUser().then(({ data }) => {
      (supabase.from("ad_clicks" as any) as any)
        .insert({ ad_type: adType, ad_id: adId, path, user_id: data.user?.id ?? null })
        .then(({ error }: any) => {
          if (error) console.warn("[adTracking] insert failed", error.message);
        });
    });
  } catch (e) {
    console.warn("[adTracking] threw", e);
  }
};

/**
 * Admin-only: fetch aggregated click counts for a given ad type.
 * Returns a Map<adId, count>.
 */
export const fetchAdClickCounts = async (adType: AdType): Promise<Map<string, number>> => {
  const { data, error } = await (supabase.rpc as any)("get_ad_click_counts", { _ad_type: adType });
  const map = new Map<string, number>();
  if (error) {
    console.warn("[adTracking] counts failed", error.message);
    return map;
  }
  (data || []).forEach((r: any) => map.set(r.ad_id, Number(r.click_count) || 0));
  return map;
};
